export default {
    titleMessageModal: 'Nouveau message',
    placeholder: 'Message text',
    btnSend: 'Send',
    btnCancel: 'Cancel'
}